import Icon from './icon';
export default {
  Icon,
  title: 'Snap',
  hotkey: 'a'
};